<template>
  <popup :close-action="closeActionClicked" :buttons="buttons" class="subscription-cta-popup">
    <template v-slot:title>
      <div class="title-content">
        <div class="subtitle">הצעה מיוחדת לזמן מוגבל</div>
        <div class="internal-title">לא הרווחת – לא שילמת!</div>
        <div class="description">
          <p>
            לקוחות רייזאפ משפרים את התזרים ב־<span class="bold">2,473 ₪ בממוצע כל חודש</span> אחרי שלושה חודשים בשירות.
          </p><br><p>
            ולנו יש הצעה מיוחדת: התחילו לשלם על המנוי כבר עכשיו, ואם בעוד שלושה חודשים תרצו לעזוב, נחזיר לכם את הכסף ששילמתם.
          </p><br><p class="bold">
            עד כדי כך אנחנו בטוחים שזה ישתלם!
          </p>
        </div>
        <subscription-mbg-timer />

      </div>
    </template>
    <template v-slot:footer>
      <div @click="notInterestedButtonClicked">לא תודה, אני אוותר</div>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import moment from 'moment';
import { mapActions, mapGetters, mapState } from 'vuex';
import benefitsApi from '@/api/BenefitsApi';
import SubscriptionMbgTimer from '@/pages/responsive-pages/authenticated/trial/money-back-offer/SubscriptionMbgTimer';
import router from '../../../../router';
import Segment from '../../../../Segment';

export default {
  name: 'SubscriptionCtaPopup',
  components: {
    SubscriptionMbgTimer,
    Popup: BaseUI.Popup,
  },
  data() {
    return {
      timeLeft: {
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      interval: null,
    };
  },
  computed: {
    ...mapState('subscriptionState', ['since', 'until', 'newPromotionsTest']),
    ...mapGetters('subscriptionState', ['daysLeft', 'trialLength', 'trialPeriod', 'mbgOfferEndDate']),
    trialProgressInPercentage() {
      return (this.daysLeft / this.trialLength) * 100;
    },
    buttons() {
      return [{
        title: 'אני בעניין!',
        action: () => {
          Segment.trackUserInteraction('SubscriptionCtaPopupMbg_SubscribeButtonClicked', { trialPeriod: this.trialPeriod });
          this.$emit('close');
          router.push({ path: '/subscription' });
        },
        variant: 'primary',
        size: 'slim',
      },
      {
        title: 'תזכירו לי מאוחר יותר',
        action: this.dismissButtonClicked,
        variant: 'secondary',
        size: 'slim',
      },
      ];
    },
  },
  created() {
    Segment.trackUserInteraction('SubscriptionCtaMbgPopupShown', { trialPeriod: this.trialPeriod });
    Segment.trackUserInteraction('JustInTimeCX_Shown', { source: this.$options.name, moneyBack: true });
    this.interval = setInterval(this.updateTimeLeft, 1000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    ...mapActions('subscriptionState', ['ctaDismissedMbg', 'fetchSubscriptionState']),
    closeActionClicked() {
      Segment.trackUserInteraction('SubscriptionCtaPopupMbg_CloseButtonClicked', { });
      this.$emit('close');
    },
    dismissButtonClicked() {
      Segment.trackUserInteraction('SubscriptionCtaPopupMbg_DismissButtonClicked', { });
      this.subscriptionCtaDismissedMbg();
    },
    async notInterestedButtonClicked() {
      Segment.trackUserInteraction('SubscriptionCtaPopupMbg_NotInterestedButtonClicked', { });
      await benefitsApi.dismissMoneyBackGuarantee();
      await this.fetchSubscriptionState();
      this.subscriptionCtaDismissedMbg();
    },
    subscriptionCtaDismissedMbg() {
      this.ctaDismissedMbg();
      this.$emit('close');
    },
    updateTimeLeft() {
      const remainingDuration = moment.duration(this.mbgOfferEndDate.diff(moment()));
      this.timeLeft = {
        hours: this.withLeadingZeros(Math.floor(remainingDuration.asHours())),
        minutes: this.withLeadingZeros(Math.floor(remainingDuration.asMinutes() % 60)),
        seconds: this.withLeadingZeros(Math.floor(remainingDuration.asSeconds() % 60)),
      };
    },
    withLeadingZeros(num) {
      return num < 10 ? `0${num}` : num;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '~base-ui/src/scss/riseup-colors';

  @keyframes spin {
    from {
      transform: rotate(-25deg);
    }
    to {
      transform: rotate(335deg);
    }
  }

  .subscription-cta-popup {
    ::v-deep .riseup-button .button-content .button-icon {
      display: inline-block;
      margin-left: 6px;
    }

    .title-content {
      font-family: SimplerPro;
      font-size: 14px;

      .subtitle {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 12px;
      }

      .internal-title {
        font-family: SimplerProBold,serif;
        font-size: 24px;
        line-height: 28px;
        margin: 0px 0 28px;
      }

      .description {
        margin-top: 8px;
        font-size: 18px;
        line-height: 24px;

        p {
          margin: 0px 0;
        }
      }

      .dates-path {
        margin-top: 3px;
      }

      .progress-bar-container {
        position: relative;
        height: 27px;

        .simple-progress-bar {
          position: absolute;
          width: 100%;
        }
      }
    }

    .content-content {
      margin-top: 30px;
      line-height: 1.5;

      .discount {
        font-size: 14px;

        .gift {
          font-weight: bold;
          margin-bottom: 10px;
        }
      }
    }
  }
</style>
